import Vue from 'vue'
import App from './App.vue'
import router from './router/routers'
import store from './store'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'  // 使用 CSS
import axios from 'axios'
// import VueAxios from 'vue-axios'
import keyboard from '@/views/salesman/components/keyboard'
import letterkeyboard from '@/views/salesman/components/letter-keyboard'
import ImageUpload from '@/views/salesman/components/ImageUpload/ImageUpload'
import BaiduMap from 'vue-baidu-map'
import VueResource from 'vue-resource'
import weui from 'weui.js'
import 'weui'

Date.prototype.Format = function (fmt) { // author: meizz
    var o = {
        'M+': this.getMonth() + 1, // 月份
        'd+': this.getDate(), // 日
        'h+': this.getHours(), // 小时
        'm+': this.getMinutes(), // 分
        's+': this.getSeconds(), // 秒
        'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
        'S': this.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length)) }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
    }
    return fmt
}
Vue.config.productionTip = false
Vue.use(iView);
Vue.use(axios);
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    // ak: 'wuQ2c8OGezvhhqHALNa8517s4z7Ni2l2'
    ak: '1vWoHbx4FLOGHNcG93t0zD2oRfDXfqDj'
})
Vue.use(VueResource)
Vue.component('keyboard', keyboard)
Vue.component('letter-keyboard', letterkeyboard)
Vue.component('ImageUpload',ImageUpload)
Vue.prototype.$Message.config({
    top: 100
});
Vue.prototype.$weui = weui

new Vue({
  router,
  store,
    // axios,
    data: function () {
        return {
            myinfo: '',
            openID: '',
            installid:'',
            maintainOrdersDetailid:'',
            salesmaintainOrdersDetailid:'',
        }
    },
  render: h => h(App)
}).$mount('#app')
